/**
 * Business expense scope: category subtree under "Business Expenses" (slug business-expenses)
 */

import {
  collectDescendantCategoryIds,
  expandCategoryIdsToDescendants,
} from '../../utils/category-tree-utils';

export type { CategoryTreeNode } from '../../utils/category-tree-utils';
export { collectDescendantCategoryIds, expandCategoryIdsToDescendants };

export interface CategoryWithTree {
  id: string;
  name: string;
  parent_id: string | null;
  slug: string | null;
  deductible?: boolean;
  gst_applicable?: boolean;
}

export const BUSINESS_EXPENSE_ROOT_SLUG = 'business-expenses';

const TRAVEL_MOTOR_PATTERNS = [
  /motor vehicle/i,
  /travel/i,
  /transport/i,
  /fuel/i,
  /parking/i,
  /mileage/i,
  /vehicle/i,
];

export function findBusinessExpenseRootId(categories: CategoryWithTree[]): string | null {
  const bySlug = categories.find((c) => c.slug === BUSINESS_EXPENSE_ROOT_SLUG);
  if (bySlug) return bySlug.id;
  const byName = categories.find((c) => c.name.toLowerCase() === 'business expenses');
  return byName?.id ?? null;
}

export function resolveBusinessCategoryScope(
  categories: CategoryWithTree[],
  wizardCategoryIds?: string[]
): Set<string> | null {
  const wizardScope = wizardCategoryIds?.length
    ? expandCategoryIdsToDescendants(wizardCategoryIds, categories)
    : null;

  const rootId = findBusinessExpenseRootId(categories);
  if (rootId) {
    const businessScope = collectDescendantCategoryIds(rootId, categories);
    if (wizardScope) {
      return new Set([...businessScope].filter((id) => wizardScope.has(id)));
    }
    return businessScope;
  }

  if (wizardScope?.size) {
    return wizardScope;
  }

  return null;
}

export function isTravelOrMotorCategoryName(name: string): boolean {
  return TRAVEL_MOTOR_PATTERNS.some((p) => p.test(name));
}
